import React, { useEffect, useState,useRef } from "react"
import "./EditCourse.scss"
import CourseApi from "Api/CourseApi"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { InputNumber } from "primereact/inputnumber"
import { useLocation, useNavigate } from "react-router-dom"
import UniversityApi from "Api/UniversityApi"
import programApi from "Api/programApi"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { Toast } from 'primereact/toast'


const EditCourse = () => {
  document.title = "Edit Course"
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const location = useLocation()
  const course = location?.state
  const userData = JSON.parse(localStorage.getItem("userData"))
  const toast = useRef(null);
  const [showCutoffForm, setShowCutoffForm] = useState(false);
  const [editingCutoffIndex, setEditingCutoffIndex] = useState(null);


  const refinedProgramData = {
    ...course,
    modeOfStudy: {
      name:
        course?.modeOfStudy.charAt(0).toUpperCase() +
        course?.modeOfStudy?.slice(1),
      code:
        course?.modeOfStudy.charAt(0).toUpperCase() +
        course?.modeOfStudy?.slice(1),
    },
    verifiedStatus: {
      name:
        course?.verifiedStatus.charAt(0)?.toUpperCase() +
        course?.verifiedStatus?.slice(1),
      code:
        course?.verifiedStatus.charAt(0)?.toUpperCase() +
        course?.verifiedStatus?.slice(1),
    },
    verifiedReason: course?.verifiedReason ? course?.verifiedReason : "",
    institution: course?.institution ? {
      _id: course.institution._id,
      institutionName: course.institution.institutionName,
      institutionCode: course.institution.institutionCode,
      category: course.institution.category,
      displayName: course.institution.displayName
    } : null,
    university: course?.university ? {
      _id: course.university._id,
      universityName: course.university.universityName,
      universityCode: course.university.universityCode,
      displayName: course.university.displayName
    } : null,
    Program: course?.Program ? {
      _id: course.Program._id,
      programName: course.Program.programName
    } : null,
    cutoffs: course?.cutoff ? course.cutoff.map(cutoff => ({
      year: cutoff.year,
      quota: cutoff.quota,
      cutoff: cutoff.cutoff,
      rounds: cutoff.rounds ? {
        round1: cutoff.rounds.round1 || "TBA",
        round2: cutoff.rounds.round2 || "TBA",
        mopUpRound: cutoff.rounds.mopUpRound || "TBA",
        strayVacancy: cutoff.rounds.strayVacancy || "TBA"
      } : null
    })) : []
  }



  const [courseData, setCourseData] = useState(refinedProgramData)
  const [currentCutoff, setCurrentCutoff] = useState({
    year: "",
    quota: "",
    cutoff: "",
    rounds: {
      round1: "TBA",
      round2: "TBA",
      mopUpRound: "TBA",
      strayVacancy: "TBA",
    },
  })

  const handleCourseDataChange = (name, value) => {
    setCourseData(prevState => ({
      ...prevState,
      [name]: value,
    }))
  }
  const verficationOption = [
    { name: "Approve", code: "Approve" },
    { name: "Reject", code: "Reject" },
    { name: "Pending", code: "Pending" },
  ]

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Course", link: "#" },
    { label: "Edit Course", link: "#" },
  ]
  const typeOptions = [
    { name: "underGraduate", code: "underGraduate" },
    { name: "postGraduate", code: "postGraduate" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]
  const modeofStudyOptions = [
    { name: "Online", code: "Online" },
    { name: "Offline", code: "Offline" },
    { name: "Hybrid", code: "Hybrid" },
  ]
  const [uniMenu, setUniMenu] = useState([])
  const universityDropDown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniMenu(res.data.university)
      })
      .catch(error => {
      })
  }
  useEffect(() => {
    universityDropDown()
    fetchInstituteByUniId(courseData?.university?.universityCode)
  }, [accessToken])
  const [programMenu, setProgramMenu] = useState([])

  const getProgramMenuList = institutionCode => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    programApi
      .getProgramByInstitue(institutionCode, courseData.institution?.category?.toLowerCase(), config)
      .then(res => {
        if (res.data.status) {
          setProgramMenu(res.data.programs)
        }
      })
      .catch(error => {
      })
  }

  const [instituteMenu, setInstituteMenu] = useState([])
  const fetchInstituteByUniId = universityCode => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
    UniversityApi.getCollegesByUniversity(universityCode, config)
      .then(res => {
        setInstituteMenu(res.data.colleges)
      })
      .catch(error => {
      })
  }

  useEffect(() => {
    getProgramMenuList(courseData?.institution?.institutionCode)
  }, [instituteMenu])

  const quotaOptions = [
    { name: "General", code: "General" },
    { name: "OBC", code: "OBC" },
    { name: "SC", code: "SC" },
    { name: "ST", code: "ST" },
    { name: "EWS", code: "EWS" },
  ]

  const handleAddCutoff = () => {
    const newCutoff = {
      year: currentCutoff.year,
      quota: currentCutoff.quota.code || currentCutoff.quota,
      cutoff: currentCutoff.cutoff,
      rounds: courseData.institution?.category?.toUpperCase() === "MEDICAL" ? {
        round1: currentCutoff.rounds.round1,
        round2: currentCutoff.rounds.round2,
        mopUpRound: currentCutoff.rounds.mopUpRound,
        strayVacancy: currentCutoff.rounds.strayVacancy,
      } : null
    }

    const updatedCutoffs = [...courseData.cutoffs, newCutoff]
    handleCourseDataChange("cutoffs", updatedCutoffs)

    // Reset the form
    setCurrentCutoff({
      year: "",
      quota: "",
      cutoff: "",
      rounds: {
        round1: "TBA",
        round2: "TBA",
        mopUpRound: "TBA",
        strayVacancy: "TBA",
      },
    })

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Cutoff added successfully",
      life: 3000,
    })
  }

  const handleRemoveCutoff = index => {
    const updatedCutoffs = courseData.cutoffs.filter((_, i) => i !== index)
    handleCourseDataChange("cutoffs", updatedCutoffs)
  }

  const updateCourse = () => {
    const payload = {
      courseId: courseData?._id,
      courseName: courseData.courseName,
      university: courseData?.university?._id,
      institution: courseData?.institution?._id,
      Program: courseData?.Program?._id,
      duration: courseData.duration,
      level: courseData.level,
      eligibilityCriteria: courseData.eligibilityCriteria,
      totalSeats: courseData.totalSeats?.toString(),
      tuitionFee: courseData.tuitionFee?.toString(),
      admissionFee: courseData.admissionFee?.toString(),
      intakeSeats: courseData.intakeSeats,
      modeOfStudy: courseData?.modeOfStudy?.name?.toLowerCase(),
      description: courseData.description,
      verifiedStatus: courseData?.verifiedStatus?.name?.toLowerCase(),
      verifiedReason: courseData.verifiedReason,
      cutoff: courseData.cutoffs
    }

    setLoading(true)

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    
    CourseApi.updateCourse(payload, config)
      .then(res => {
        if (res.data.status) {
          setLoading(false)
          toast.current.show({
            severity: 'success',
            summary: 'Success',
            detail: res.data.message,
            life: 3000
          });
          setTimeout(() => {
            navigate("/courselist")
          }, 1000)
        } else {
          setLoading(false)
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: res.data.message || 'Error updating course',
            life: 3000
          });
        }
      })
      .catch(error => {
        setLoading(false)
        const errorMessage = error.response?.data?.message || 'Error updating course';
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage,
          life: 3000
        });
      })
  }

  const handleUpdateCourse = () => {
    updateCourse();
  }

  const startEditingCutoff = (index) => {
    setEditingCutoffIndex(index);
  };

  const saveCutoffEdit = () => {
    setEditingCutoffIndex(null);
  };

  // Add this function to check if a field is empty
  const isFieldEmpty = (value) => {
    if (value === undefined || value === null) return true;
    if (typeof value === 'string') return value.trim() === '';
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    return false;
  }

  return (
    <div className=" edit-course">
      <Toast ref={toast} />
      <Row>
        <Col xs="12">
          <div className="course-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Edit Course" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="course-edit-form ">
                <div className="course-edit-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={courseData.university}
                      onChange={e => {
                        handleCourseDataChange("university", e.value)
                        fetchInstituteByUniId(e.value.universityCode)
                      }}
                      options={uniMenu}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label
                    htmlFor="
                          Institution"
                  >
                    Institution
                  </label>

                  <div className="inp-err">
                    <Dropdown
                      value={courseData?.institution}
                      onChange={e => {
                        handleCourseDataChange("institution", e.value)
                        getProgramMenuList(e.value.institutionCode)
                      }}
                      options={instituteMenu}
                      optionLabel="institutionName"
                      placeholder="Select Institution"
                      filter
                      className="w-100"
                    />
                  </div>
                </div>
                <div className="course-edit-inp">
                  <label htmlFor="CourseName">Program Name</label>

                  <div className="inp-err">
                    <Dropdown
                      id="courseName"
                      value={courseData.Program}
                      onChange={e => handleCourseDataChange("Program", e.value)}
                      options={programMenu}
                      optionLabel="programName"
                      placeholder="Choose Prorgam"
                      filter
                    />
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="courseName" className="label">
                    Course Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="courseName"
                      value={courseData.courseName}
                      onChange={e =>
                        handleCourseDataChange("courseName", e.target.value)
                      }
                      placeholder="Enter Course Name"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="duration"
                      value={courseData.duration}
                      onChange={e =>
                        handleCourseDataChange("duration", e.target.value)
                      }
                      placeholder="Enter Duration"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="level"
                      value={courseData.level}
                      onChange={e =>
                        handleCourseDataChange("level", e.target.value)
                      }
                      placeholder="Enter Level"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="EligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="eligibilityCriteria"
                      value={courseData.eligibilityCriteria}
                      onChange={e =>
                        handleCourseDataChange(
                          "eligibilityCriteria",
                          e.target.value,
                        )
                      }
                      placeholder="Enter EligibilityCriteria"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalSeats"
                      value={courseData.totalSeats}
                      onChange={e =>
                        handleCourseDataChange("totalSeats", e.target.value)
                      }
                      placeholder="Enter TotalSeats"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="tuitionFee"
                      value={courseData.tuitionFee}
                      onChange={e =>
                        handleCourseDataChange("tuitionFee", e.target.value)
                      }
                      placeholder="Enter TuitionFee"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="admissionFee"
                      value={courseData.admissionFee}
                      onChange={e =>
                        handleCourseDataChange("admissionFee", e.target.value)
                      }
                      placeholder="Enter AdmissionFee"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="intakeSeats" className="label">
                    Intake Seats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="intakeSeats"
                      value={courseData.intakeSeats}
                      onChange={e =>
                        handleCourseDataChange("intakeSeats", e.target.value)
                      }
                      placeholder="Enter Intake Seats"
                      className="inp-field-box"
                    />  
                  </div>
                </div>

                <div className="course-edit-inp">
                  <label htmlFor="modeOfStudy">Mode Of Study</label>
                  <div className="inp-err">
                    <Dropdown
                      id="modeOfStudy"
                      value={courseData.modeOfStudy}
                      onChange={e =>
                        handleCourseDataChange("modeOfStudy", e.value)
                      }
                      optionLabel="name"
                      options={modeofStudyOptions}
                      placeholder=" Select Mode of Study"
                    />
                  </div>
                </div>
                <div className="course-edit-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={courseData.description}
                      onChange={e =>
                        handleCourseDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                {/* Cutoff Section */}
                <div className="course-edit-inp">
                  <label>Cutoffs</label>
                  <div className="cutoff-section">
                    {showCutoffForm ? (
                      <div className="cutoff-input-form">
                        <div className="mb-2">
                          <label htmlFor="year">Year</label>
                          <div className="inp-err">
                            <Calendar
                              id="year"
                              value={
                                currentCutoff.year
                                  ? new Date(currentCutoff.year, 0)
                                  : null
                              }
                              onChange={e => {
                                const selectedYear = e.value
                                  ? new Date(e.value).getFullYear()
                                  : null
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  year: selectedYear,
                                })
                              }}
                              view="year"
                              dateFormat="yy"
                              placeholder="Select Year"
                              showIcon
                            />
                          </div>
                        </div>

                        <div className="mb-2">
                          <label htmlFor="quota">Quota</label>
                          <div className="inp-err">
                            <Dropdown
                              id="quota"
                              value={currentCutoff.quota}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  quota: e.value,
                                })
                              }
                              options={quotaOptions}
                              optionLabel="name"
                              placeholder="Select Quota"
                            />
                          </div>
                        </div>

                        {courseData.institution?.category?.toUpperCase() !== "MEDICAL" && (
                          <div className="mb-2">
                            <label htmlFor="cutoff">Cutoff</label>
                            <div className="inp-err">
                              <InputText
                                id="cutoff"
                                value={currentCutoff.cutoff}
                                onChange={e =>
                                  setCurrentCutoff({
                                    ...currentCutoff,
                                    cutoff: e.target.value,
                                  })
                                }
                                placeholder="Enter Cutoff"
                              />
                            </div>
                          </div>
                        )}

                        {courseData.institution?.category?.toUpperCase() === "MEDICAL" && (
                          <div className="rounds-grid">
                            <div>
                              <label htmlFor="round1">Round 1</label>
                              <div className="inp-err">
                                <InputText
                                  id="round1"
                                  value={currentCutoff.rounds.round1}
                                  onChange={e =>
                                    setCurrentCutoff({
                                      ...currentCutoff,
                                      rounds: {
                                        ...currentCutoff.rounds,
                                        round1: e.target.value,
                                      },
                                    })
                                  }
                                  placeholder="Round 1 Cutoff"
                                />
                              </div>
                            </div>

                            <div>
                              <label htmlFor="round2">Round 2</label>
                              <div className="inp-err">
                                <InputText
                                  id="round2"
                                  value={currentCutoff.rounds.round2}
                                  onChange={e =>
                                    setCurrentCutoff({
                                      ...currentCutoff,
                                      rounds: {
                                        ...currentCutoff.rounds,
                                        round2: e.target.value,
                                      },
                                    })
                                  }
                                  placeholder="Round 2 Cutoff"
                                />
                              </div>
                            </div>

                            <div>
                              <label htmlFor="mopUpRound">Mop-Up Round</label>
                              <div className="inp-err">
                                <InputText
                                  id="mopUpRound"
                                  value={currentCutoff.rounds.mopUpRound}
                                  onChange={e =>
                                    setCurrentCutoff({
                                      ...currentCutoff,
                                      rounds: {
                                        ...currentCutoff.rounds,
                                        mopUpRound: e.target.value,
                                      },
                                    })
                                  }
                                  placeholder="Mop-Up Round Cutoff"
                                />
                              </div>
                            </div>

                            <div>
                              <label htmlFor="strayVacancy">Stray Vacancy</label>
                              <div className="inp-err">
                                <InputText
                                  id="strayVacancy"
                                  value={currentCutoff.rounds.strayVacancy}
                                  onChange={e =>
                                    setCurrentCutoff({
                                      ...currentCutoff,
                                      rounds: {
                                        ...currentCutoff.rounds,
                                        strayVacancy: e.target.value,
                                      },
                                    })
                                  }
                                  placeholder="Stray Vacancy Cutoff"
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="add-cutoff-btn d-flex gap-2">
                          <Button
                            type="button"
                            color="primary"
                            size="sm"
                            onClick={() => {
                              handleAddCutoff();
                              setShowCutoffForm(false);
                            }}
                          >
                            Save Cutoff
                          </Button>
                          <Button
                            type="button"
                            color="danger"
                            size="sm"
                            onClick={() => {
                              setShowCutoffForm(false);
                              setCurrentCutoff({
                                year: "",
                                quota: "",
                                cutoff: "",
                                rounds: {
                                  round1: "TBA",
                                  round2: "TBA",
                                  mopUpRound: "TBA",
                                  strayVacancy: "TBA",
                                },
                              });
                            }}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    ) : null}

                    {courseData.cutoffs && courseData.cutoffs.length > 0 && (
                      <div className="cutoff-list mt-3">
                        <h6>Added Cutoffs:</h6>
                        {courseData.cutoffs.map((cutoff, index) => (
                          <div
                            key={index}
                            className="cutoff-item p-2 border rounded mb-2"
                          >
                            {editingCutoffIndex === index ? (
                              <div className="edit-cutoff-form">
                                <div className="mb-2">
                                  <label htmlFor="year">Year</label>
                                  <div className="inp-err">
                                    <Calendar
                                      id="year"
                                      value={
                                        cutoff.year
                                          ? new Date(cutoff.year, 0)
                                          : null
                                      }
                                      onChange={e => {
                                        const selectedYear = e.value
                                          ? new Date(e.value).getFullYear()
                                          : null
                                        const updatedCutoffs = [...courseData.cutoffs];
                                        updatedCutoffs[index] = {
                                          ...updatedCutoffs[index],
                                          year: selectedYear
                                        };
                                        handleCourseDataChange("cutoffs", updatedCutoffs);
                                      }}
                                      view="year"
                                      dateFormat="yy"
                                      placeholder="Select Year"
                                      showIcon
                                    />
                                  </div>
                                </div>

                                <div className="mb-2">
                                  <label htmlFor="quota">Quota</label>
                                  <div className="inp-err">
                                    <Dropdown
                                      id="quota"
                                      value={quotaOptions.find(option => option.code === cutoff.quota) || null}
                                      onChange={e => {
                                        const updatedCutoffs = [...courseData.cutoffs];
                                        updatedCutoffs[index] = {
                                          ...updatedCutoffs[index],
                                          quota: e.value.code
                                        };
                                        handleCourseDataChange("cutoffs", updatedCutoffs);
                                      }}
                                      options={quotaOptions}
                                      optionLabel="name"
                                      placeholder="Select Quota"
                                    />
                                  </div>
                                </div>

                                {courseData.institution?.category?.toUpperCase() !== "MEDICAL" && (
                                  <div className="mb-2">
                                    <label htmlFor="cutoff">Cutoff</label>
                                    <div className="inp-err">
                                      <InputText
                                        id="cutoff"
                                        value={cutoff.cutoff}
                                        onChange={e => {
                                          const updatedCutoffs = [...courseData.cutoffs];
                                          updatedCutoffs[index] = {
                                            ...updatedCutoffs[index],
                                            cutoff: e.target.value
                                          };
                                          handleCourseDataChange("cutoffs", updatedCutoffs);
                                        }}
                                        placeholder="Enter Cutoff"
                                      />
                                    </div>
                                  </div>
                                )}

                                {courseData.institution?.category?.toUpperCase() === "MEDICAL" && (
                                  <div className="rounds-grid">
                                    <div>
                                      <label htmlFor="round1">Round 1</label>
                                      <div className="inp-err">
                                        <InputText
                                          id="round1"
                                          value={cutoff.rounds.round1}
                                          onChange={e => {
                                            const updatedCutoffs = [...courseData.cutoffs];
                                            updatedCutoffs[index] = {
                                              ...updatedCutoffs[index],
                                              rounds: {
                                                ...updatedCutoffs[index].rounds,
                                                round1: e.target.value
                                              }
                                            };
                                            handleCourseDataChange("cutoffs", updatedCutoffs);
                                          }}
                                          placeholder="Round 1 Cutoff"
                                        />
                                      </div>
                                    </div>

                                    <div>
                                      <label htmlFor="round2">Round 2</label>
                                      <div className="inp-err">
                                        <InputText
                                          id="round2"
                                          value={cutoff.rounds.round2}
                                          onChange={e => {
                                            const updatedCutoffs = [...courseData.cutoffs];
                                            updatedCutoffs[index] = {
                                              ...updatedCutoffs[index],
                                              rounds: {
                                                ...updatedCutoffs[index].rounds,
                                                round2: e.target.value
                                              }
                                            };
                                            handleCourseDataChange("cutoffs", updatedCutoffs);
                                          }}
                                          placeholder="Round 2 Cutoff"
                                        />
                                      </div>
                                    </div>

                                    <div>
                                      <label htmlFor="mopUpRound">Mop-Up Round</label>
                                      <div className="inp-err">
                                        <InputText
                                          id="mopUpRound"
                                          value={cutoff.rounds.mopUpRound}
                                          onChange={e => {
                                            const updatedCutoffs = [...courseData.cutoffs];
                                            updatedCutoffs[index] = {
                                              ...updatedCutoffs[index],
                                              rounds: {
                                                ...updatedCutoffs[index].rounds,
                                                mopUpRound: e.target.value
                                              }
                                            };
                                            handleCourseDataChange("cutoffs", updatedCutoffs);
                                          }}
                                          placeholder="Mop-Up Round Cutoff"
                                        />
                                      </div>
                                    </div>

                                    <div>
                                      <label htmlFor="strayVacancy">Stray Vacancy</label>
                                      <div className="inp-err">
                                        <InputText
                                          id="strayVacancy"
                                          value={cutoff.rounds.strayVacancy}
                                          onChange={e => {
                                            const updatedCutoffs = [...courseData.cutoffs];
                                            updatedCutoffs[index] = {
                                              ...updatedCutoffs[index],
                                              rounds: {
                                                ...updatedCutoffs[index].rounds,
                                                strayVacancy: e.target.value
                                              }
                                            };
                                            handleCourseDataChange("cutoffs", updatedCutoffs);
                                          }}
                                          placeholder="Stray Vacancy Cutoff"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}

                                <div className="d-flex gap-2">
                                  <Button
                                    type="button"
                                    color="success"
                                    size="sm"
                                    onClick={saveCutoffEdit}
                                  >
                                    Save
                                  </Button>
                                  <Button
                                    type="button"
                                    color="danger"
                                    size="sm"
                                    onClick={() => setEditingCutoffIndex(null)}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                            ) : (
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <strong>Year: {cutoff.year}</strong>
                                  <p className="mb-0">Quota: {cutoff.quota}</p>
                                  {courseData.institution?.category?.toUpperCase() !== "MEDICAL" && (
                                    <p className="mb-0">Cutoff: {cutoff.cutoff}</p>
                                  )}
                                  {courseData.institution?.category?.toUpperCase() === "MEDICAL" && (
                                    <div className="rounds-values">
                                      <small>
                                        Round 1: {cutoff.rounds.round1}
                                      </small>
                                      <small className="ms-2">
                                        Round 2: {cutoff.rounds.round2}
                                      </small>
                                      <small className="ms-2">
                                        Mop-Up: {cutoff.rounds.mopUpRound}
                                      </small>
                                      <small className="ms-2">
                                        Stray: {cutoff.rounds.strayVacancy}
                                      </small>
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex gap-2">
                                  <Button
                                    type="button"
                                    color="primary"
                                    size="sm"
                                    onClick={() => startEditingCutoff(index)}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    type="button"
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleRemoveCutoff(index)}
                                  >
                                    Remove
                                  </Button>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="add-cutoff-btn mt-3">
                      <Button
                        type="button"
                        color="primary"
                        size="sm"
                        onClick={() => {
                          setShowCutoffForm(true);
                          setCurrentCutoff({
                            year: "",
                            quota: "",
                            cutoff: "",
                            rounds: {
                              round1: "TBA",
                              round2: "TBA",
                              mopUpRound: "TBA",
                              strayVacancy: "TBA",
                            },
                          });
                        }}
                      >
                        Add Cutoff
                      </Button>
                    </div>
                  </div>
                </div>

                {userData.role === "manager" && (
                  <>
                    <div className="course-edit-inp">
                      <label htmlFor="verifiedStatus" className="label">
                        Verification
                      </label>
                      <div className="inp-err ">
                        <Dropdown
                          id="verifiedStatus"
                          value={courseData.verifiedStatus}
                          onChange={e =>
                            handleCourseDataChange("verifiedStatus", e.value)
                          }
                          options={verficationOption}
                          optionLabel="name"
                          placeholder="Select Verification Status"
                          className="inp-field-box"
                        />
                      </div>
                    </div>

                    <div className="course-edit-inp">
                      <label htmlFor="verifiedReason" className="label">
                        Verification Reason
                      </label>
                      <div className="inp-err">
                        <InputText
                          id="verifiedReason"
                          value={courseData.verifiedReason}
                          onChange={e =>
                            handleCourseDataChange(
                              "verifiedReason",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Verification Reason"
                          className="inp-field-box"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  disabled={loading}
                  onClick={handleUpdateCourse}
                >
                  {loading ? <Spinner size="sm" /> : "Update"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditCourse
